import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Checkbox, Dropdown, Menu, Spin, Table } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import get from 'lodash/get'

import { employeeSelector, getEmployeesAction } from '../../../store/employeе'
import usePagination from '../../hooks/usePagination'
import { getRoleName } from '../../../utils/user-utils'
import useTableFilter from '../../hooks/useTableFilter'
import { userSelector } from '../../../store/session'
import EmployeeModal from '../EmployeeModal'
import { blockEmployee } from '../EmployeeBlock'

const EmployeesTable = () => {
  const dispatch = useDispatch()

  const [showEmployeeDetail, setShowEmployeeDetail] = useState(false)
  const [selectedEmployee, setSelectedEmployee] = useState(null)

  const [tablePagination] = usePagination(0, 20)

  const [filter, searchText, searchedColumn, getColumnSearchProps] = useTableFilter()

  const { isFetching, employees } = useSelector(employeeSelector)

  const { user } = useSelector(userSelector)
  const isProject = useMemo(() => user?.role?.type === 'project_manager', [user])

  const onEditEmployeeAction = (id) => {
    setSelectedEmployee(id)
    setShowEmployeeDetail(true)
  }

  const renderActionsMenu = (_, record) => {
    const menu = (
      <Menu>
        <Menu.Item key="edit" onClick={() => onEditEmployeeAction(record.id)} type="dashed">
          Редактировать
        </Menu.Item>
        <Menu.Item key="block" onClick={() => blockEmployee(record, loadEmployees)} type="dashed">
          Заблокировать
        </Menu.Item>
      </Menu>
    )
    return (
      isProject && (
        <Dropdown overlay={menu} disabled={record.children}>
          <a>
            Действия <DownOutlined />
          </a>
        </Dropdown>
      )
    )
  }

  const columns = [
    {
      title: 'Имя пользователя',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Почта',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Имя',
      dataIndex: 'first_name',
      key: 'first_name',
      ...getColumnSearchProps('first_name'),
      onFilter: (value, record) => get(record, 'first_name').toString().toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Фамилия',
      dataIndex: 'second_name',
      key: 'second_name',
      ...getColumnSearchProps('second_name'),
      onFilter: (value, record) => get(record, 'second_name').toString().toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Роль',
      dataIndex: 'role',
      key: 'role',
      render: (role) => getRoleName(role?.name),
    },
    {
      title: 'Заблокирован',
      dataIndex: 'blocked',
      key: 'blocked',
      width: 120,
      render: (blocked) => <Checkbox checked={blocked} disabled={true} />,
    },
    {
      title: 'Действия',
      key: 'actions',
      width: 110,
      render: renderActionsMenu,
    },
  ]

  const onEmployeeDialogClose = useCallback(() => {
    setShowEmployeeDetail(false)
    setSelectedEmployee(null)
  }, [])

  const onEmployeeDialogSuccess = useCallback(() => {
    onEmployeeDialogClose()
    loadEmployees()
  }, [])

  const loadEmployees = useCallback(() => dispatch(getEmployeesAction({})), [dispatch])

  useEffect(() => {
    if (!employees || employees.length === 0) {
      loadEmployees()
    }
  }, [dispatch])

  return (
    <div>
      <Spin spinning={isFetching}>
        <Table
          rowKey="id"
          size="small"
          bordered
          style={{ marginTop: '20px' }}
          pagination={tablePagination}
          columns={columns}
          dataSource={employees}
        />
      </Spin>
      <EmployeeModal
        showModal={showEmployeeDetail}
        userId={selectedEmployee}
        onClose={onEmployeeDialogClose}
        onSuccess={onEmployeeDialogSuccess}
      />
    </div>
  )
}

export default EmployeesTable
